import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import getHeaderData from 'config/HeaderData';
import AuthService from 'services/AuthService';
import styles from './NavbarMenu.module.css';
import { useSelector } from 'react-redux';
import { CircularProgress, Tooltip } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { getApi } from 'api/axios';
import { errorToast, successToast } from 'components/common/Toast/Toast';
import ConfirmDialog from 'components/common/ConfirmDialog/ConfirmDialog';
import { useUserApi } from 'hooks/useUserApi';
import HeaderProfile from '../HeaderProfile/HeaderProfile';
import { useTranslation } from 'react-i18next';
const NavbarMenu = ({ user }) => {
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);
  const { t } = useTranslation();
  const { getCurrentUser } = useUserApi();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const HeaderData = getHeaderData(t);

  const launchShop = async () => {
    setLoading(true);
    try {
      const res = await (
        await getApi({
          baseUrl: window._env_.REACT_APP_QDAK_PRODUCT_URL
        })
      ).patch(`/admin/shops/${shopId}/clear`);
      if (res.status >= 200 && res.status < 300) {
        successToast(t('navbarMenu.successfulShop'));
        setOpen(false);
        getCurrentUser();
      }
      setLoading(false);
    } catch (e) {
      errorToast(t('navbarMenu.unsuccessfulShop'));
      console.log(e);
      setLoading(false);
    }
  };

  const handleLogout = () => {
    AuthService.doLogout();
  };

  return (
    <List component='nav' className={styles.bigList}>
      {AuthService.isLoggedIn() && (
        <>
          {/* {user?.groups?.find((group) => group === 'users') &&
            user?.ownedShops?.find((shop) => shop.id === shopId)?.isDemo === true && (
              <Tooltip title={'Élesítés'}>
                <ListItem
                  button
                  onClick={(e) => {
                    setOpen(true);
                  }}
                  className={styles.listItem}>
                  Demo
                </ListItem>
              </Tooltip>
            )} */}
          {(user?.groups?.find((group) => group === 'dt_admin') ||
            user?.groups?.find((group) => group === 'printer_admin')) && (
            <Tooltip title={'Kijelentkezés'}>
              <ListItem
                button
                onClick={(e) => {
                  handleLogout();
                }}
                className={styles.listItem}>
                {HeaderData.logoutOption.icon}
              </ListItem>
            </Tooltip>
          )}

          {user?.groups?.find((group) => group === 'users') && (
            <HeaderProfile user={user} handleLogout={handleLogout} />
          )}
        </>
      )}
      <ConfirmDialog
        open={open}
        title={t('navbarMenu.sureShop')}
        text={t('navbarMenu.attentionShop')}
        text2={t('navbarMenu.textShop')}
        functionButtonText={loading ? <CircularProgress size={23} color='green' /> : t('navbarMenu.activateShop')}
        functionButtonColor={'green'}
        closeButtonText={t('common.cancel')}
        onOk={() => {
          launchShop();
        }}
        onClose={() => {
          setOpen(false);
        }}
        multipleButtons
        disabled={loading}
      />
    </List>
  );
};

export default NavbarMenu;
